resourcePaths = '{"rootPath":"/member","assetsPath":"/member/assets"}';/*
    ProgressBar

    A progress bar that displays progress percentage with step titles.
    Provides methods to track and set progress. Updates the UI to current progress
    state.

    Arguments:
        steps (required) [[object]]:
            An array of steps. Each step is an object of title, percentage of the progress,
             and if the title should be displayed on the bar.
        percentage (optional) [integer]:
            The initial progress percentage

    HTML structure:
        div(
          data-mogo-ui="ProgressPercent"
          data-mogo-ui-steps="[
            {percentage: 10, title: 'title1', visible: false},
            {percentage: 50, title: 'title2', visibale: true}
          ]"
          data-mogo-ui-percentage="50"
        )

    Methods (see methods for  additional usage):
        setPercentage(percent)
        getPercent()
*/
function ProgressBar () {
  this.id = null;
  this.node = null;
  this.declaredClass = null;
  this.extends = [];

  this.percentage = 0;
  this.steps = [];

  this._totalSteps = 0;
  this._currentStep = 0;

  this.init = function () {
    $(this.node).addClass('progress-bar');
    this._titles = $('<div class="progress-bar__titles"></div>');
    this._bar = $('<div class="progress-bar__track"><div class="progress-bar__track-percent"></div></div>');
    this._pointer = $('<div class="progress-bar__pointer"><div class="progress-bar__pointer-arrow"></div>');
    $(this.node).append(this._titles);
    $(this.node).append(this._bar);
    $(this.node).append(this._pointer);
    this._totalSteps = this.steps.length;
    for (var i = 0; i < this._totalSteps; i++) {
      // generate titles
      var title = $('<div class="progress-bar__title"><span class="a11y__hidden-content">Step ' + (i + 1) + '</span><span>' + this.steps[i].title + '</span></div>');
      if (!this.steps[i].visible) {
        title.addClass('a11y__hidden-content');
      }
      this._titles.append(title);
      if (i === 0) {
        title.css('left', 0);
      } else if (i === this._totalSteps - 1) {
        title.css('right', 0);
      } else {
        // Page switch fix : (
        if (title.width() === 0) title.css('width', '70px'); 
        var offset = title.width() / 2;
        title.css('left', 'calc(' + this.steps[i].percentage + '% - ' + offset + 'px)');
      }
      // generate dot
      if (this.steps[i].visible) {
        var dot = $('<div class="progress-bar__track-dot" style="left:calc(' + this.steps[i].percentage + '%' + ' - 3px)"></div>');
        this._bar.append(dot);
      }
    }
  };

  this.initAllReady = function () {
    this.setPercentage(this.percentage);
  };

  /*
      Sets the current percentage of progress.

      Arguments:
          percent [integer] (required):
              A valid integer denoting the new progress percentage value. The value must be between
              0 and 100.
      Returns:
  */
  this.setPercentage = function (percent) {
    this.percentage = percent;
    this._bar.find('.progress-bar__track-percent').css('width', this.percentage + '%');
    this._pointer.find('.progress-bar__pointer-arrow').css('left', 'calc(' + this.percentage + '% - 8px)');
    var titlesArr = this._titles.find('.progress-bar__title');
    var lastVisibleTitle = null;
    for (var i = 0; i < this.steps.length; i++) {
      if (this.steps[i].visible) {
        lastVisibleTitle = titlesArr[i];
      }
      if (
        this.steps[i].percentage === this.percentage ||
        (this.steps[i].percentage < this.percentage && this.steps[i + 1] && this.steps[i + 1].percentage > this.percentage)
      ) {
        lastVisibleTitle.addClass('progress-bar__title--highlighted');
      } else {
        titlesArr[i].removeClass('progress-bar__title--highlighted');
      }
    }
  };

  /*
      Returns the current percentage.

      Returns:
          [integer]
              Returns the current percentage of progress.

  */
  this.getPercentage = function () {
    return this.percentage;
  };

  /*
     Sets the current step number.

     Arguments:
         stemNumber [integer] (required):
             A valid integer denoting the target step. The value must be between
             1 and total steps.
     Returns:
 */
  this.setCurrentStep = function (stepNumber) {
    this._currentStep = stepNumber;
    this.setPercentage(this.steps[this._currentStep - 1].percentage);
    var currentStepEl = $('<div class="a11y__hidden-content">Current step is ' + this._currentStep + '</div>');
    $(this.node).append(currentStepEl);
  };

  /*
      Returns the current step.

      Returns:
          [integer]
              Returns the current step.

  */
  this.getCurrentStep = function () {
    return this._currentStep;
  };
}
